import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import "./Service.css";
import customerService from "../../../Image/customer-service.png";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import logistics from "../../../Image/logistics.png";
import virtual from "../../../Image/virtual.png";
import puzzle from "../../../Image/puzzle.png";

const useStyles = makeStyles({
  serviceHeading: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "30px 0",
  },
  serviceImg: {
    margin: "0 auto",
  },
});

const Service = () => {
  const classes = useStyles();
  const [activeColor, setActiveColor] = useState("serviceCard1");
  return (
    <div>
      <Container>
        <div className="service">
          <Box className={classes.serviceHeading}>
            <Typography variant="h2">Features</Typography>
            <button className="common-btn">Get Started</button>
          </Box>
          <Grid container spacing={4}>
            <Grid item xs={12} lg={3} md={3}>
              <Box
                onClick={() => setActiveColor("serviceCard1")}
                className={`serviceCard ${
                  activeColor === "serviceCard1"
                    ? "serviceActive"
                    : "serviceCard"
                }`}
              >
                <Box>
                  <Avatar
                    alt="Remy Sharp"
                    src={virtual}
                    className={classes.serviceImg}
                  />
                </Box>
                <Box>
                  <Typography variant="h5">Digitalized </Typography>
                </Box>
                <Box>
                  <Typography variant="h5">Booking</Typography>
                </Box>
                <Box>
                  <Typography variant="h5" className="hiddenText">
                    Booking
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="span" className="iconContainer">
                    <ArrowForwardIcon />
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Box
                onClick={() => setActiveColor("serviceCard2")}
                className={`serviceCard ${
                  activeColor === "serviceCard2" ? "serviceActive" : ""
                }`}
              >
                <Box>
                  <Avatar
                    alt="Remy Sharp"
                    src={customerService}
                    className={classes.serviceImg}
                  />
                </Box>
                <Box>
                  <Typography variant="h5">24*7 </Typography>
                </Box>
                <Box>
                  <Typography variant="h5">Customer</Typography>
                </Box>
                <Box>
                  <Typography variant="h5">Support</Typography>
                </Box>
                <Box>
                  <Typography variant="span" className="iconContainer">
                    <ArrowForwardIcon />
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Box
                onClick={() => setActiveColor("serviceCard3")}
                className={`serviceCard ${
                  activeColor === "serviceCard3" ? "serviceActive" : ""
                }`}
              >
                <Box>
                  <Avatar
                    alt="Remy Sharp"
                    src={logistics}
                    className={classes.serviceImg}
                  />
                </Box>
                <Box>
                  <Typography variant="h5">On-demand</Typography>
                </Box>
                <Box>
                  <Typography variant="h5">Logistics</Typography>
                </Box>
                <Box>
                  <Typography variant="h5">Solutions</Typography>
                </Box>
                <Box>
                  <Typography variant="span" className="iconContainer">
                    <ArrowForwardIcon />
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Box
                onClick={() => setActiveColor("serviceCard4")}
                className={`serviceCard ${
                  activeColor === "serviceCard4" ? "serviceActive" : ""
                }`}
              >
                <Box>
                  <Avatar
                    alt="Remy Sharp"
                    src={puzzle}
                    className={classes.serviceImg}
                  />
                </Box>
                <Box>
                  <Typography variant="h5">Add on </Typography>
                </Box>
                <Box>
                  <Typography variant="h5">Services</Typography>
                </Box>
                <Box>
                  <Typography variant="h5" className="hiddenText">
                    Booking
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="span" className="iconContainer">
                    <ArrowForwardIcon />
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default Service;
